import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import '../style.css';
import '../nov.css';

const About = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      title: "Empowering",
      subtitle: "Artists",
      highlight: "Worldwide"
    },
    {
      title: "Distributing",
      subtitle: "Music",
      highlight: "Globally"
    },
    {
      title: "Protecting",
      subtitle: "Your",
      highlight: "Rights"
    }
  ];

  useEffect(() => {
    const cards = document.querySelectorAll('#about .group');

    const handleMouseOver = (card) => {
      cards.forEach(otherCard => {
        if (otherCard !== card) {
          otherCard.style.filter = 'blur(4px)';
        }
      });
    };

    const handleMouseOut = () => {
      cards.forEach(otherCard => {
        otherCard.style.filter = 'blur(0px)';
      });
    };

    cards.forEach(card => {
      card.addEventListener('mouseover', () => handleMouseOver(card));
      card.addEventListener('mouseout', handleMouseOut);
    });

    return () => {
      cards.forEach(card => {
        card.removeEventListener('mouseover', () => handleMouseOver(card));
        card.removeEventListener('mouseout', handleMouseOut);
      });
    };
  }, []);

  // Auto slide effect
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 3000); // 3 saniyede bir değişir

    return () => clearInterval(timer);
  }, [slides.length]);

  return (
    <>
    <section id="about" className="min-h-screen bg-[#f5f5f7] py-32 lg:py-48 relative overflow-hidden">
      <div className="container mx-auto px-6 lg:px-16 max-w-[1400px] relative z-10">
        <div className="w-full flex flex-col lg:flex-row items-center lg:items-start justify-between gap-16 lg:gap-24">
          
          {/* Sol Taraf - İçerik */}
          <div className="lg:w-5/12 text-center lg:text-left space-y-10 animate-fade-in-up">
            <div className="inline-block animate-fade-in-up animation-delay-100">
              <span className="text-xs font-medium badge-gradient text-gray-700 py-2.5 px-5 rounded-full inline-block uppercase tracking-wide" style={{ fontFamily: 'aesthet-nova' }}>
                About Media Nov
              </span>
            </div>

            <div className="space-y-6 relative overflow-hidden h-[240px] md:h-[280px] lg:h-[320px]">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`absolute inset-0 transition-all duration-700 ease-in-out ${
                    index === currentSlide 
                      ? 'opacity-100 translate-x-0' 
                      : index < currentSlide 
                        ? 'opacity-0 -translate-x-full' 
                        : 'opacity-0 translate-x-full'
                  }`}
                >
                  <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold leading-[1.1] tracking-tight uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                    <span style={{ color: 'rgb(70, 52, 135)' }}>
                      {slide.title}
                    </span>
                    <br/>
                    <span 
                      style={{ '--shimmer-width': '250px' }} 
                      className="text-neutral-600/50 animate-shimmer bg-clip-text bg-no-repeat [background-position:0_0] [background-size:var(--shimmer-width)_100%] [transition:background-position_1s_cubic-bezier(.6,.6,0,1)_infinite] bg-gradient-to-r from-neutral-100 via-black/80 via-50% to-neutral-100"
                    >
                      {slide.subtitle}
                    </span>
                    <br/>
                    <span style={{ color: 'rgb(70, 52, 135)' }}>
                      {slide.highlight}
                    </span>
                  </h1>
                </div>
              ))}
              
              {/* Slide indicators */}
              <div className="absolute bottom-0 left-0 lg:left-auto flex gap-2 z-10">
                {slides.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    className={`w-2 h-2 rounded-full transition-all duration-300 ${
                      index === currentSlide 
                        ? 'bg-gray-900 w-8' 
                        : 'bg-gray-300 hover:bg-gray-400'
                    }`}
                    aria-label={`Slide ${index + 1}`}
                  />
                ))}
              </div>
            </div>

            <p className="text-lg md:text-xl font-light text-gray-600 leading-relaxed max-w-2xl mx-auto lg:mx-0 mt-8" style={{ fontFamily: 'aesthet-nova' }}>
              Founded in 1996 as part of Media Nov Inc. We empower artists and protect their rights through secure global music distribution, ensuring your music reaches listeners worldwide.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start pt-6">
              <Link 
                to="/contact"
                className="inline-flex items-center justify-center px-8 py-4 font-medium rounded-full transition-all duration-500 button-shimmer-dark"
              >
                Get Started
              </Link>
              
              <Link 
                to="/services"
                className="inline-flex items-center justify-center px-8 py-4 font-medium rounded-full transition-all duration-500 button-shimmer"
              >
                Learn More
              </Link>
            </div>
          </div>

          {/* Sağ Taraf - Feature Cards */}
          <div className="lg:w-7/12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 animate-fade-in-up animation-delay-300">
            
            {/* GLOBAL DISTRIBUTION */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-1" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3.055 11H5a2 2 0 012 2v1a2 2 0 002 2 2 2 0 012 2v2.945M8 3.935V5.5A2.5 2.5 0 0010.5 8h.5a2 2 0 012 2 2 2 0 104 0 2 2 0 012-2h1.064M15 20.488V18a2 2 0 012-2h3.064M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Global Distribution</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">Deliver your music to all major platforms worldwide</p>
              </div>
            </div>

            {/* COPYRIGHT PROTECTION */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-2" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Copyright Protection</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">Your music is protected with industry-leading security</p>
              </div>
            </div>

            {/* ROYALTY COLLECTION */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-3" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Royalty Collection</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">Collect all royalties owed to you, paid fairly</p>
              </div>
            </div>

            {/* ARTIST SUPPORT */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-4" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Artist Support</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">Dedicated support team, every step of the way</p>
              </div>
            </div>

            {/* MUSIC PUBLISHING */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-5" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Music Publishing</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">Get your music into films, TV shows, and more</p>
              </div>
            </div>

            {/* RIGHTS MANAGEMENT */}
            <div className="group relative bg-white rounded-[24px] p-6 transition-all duration-200 hover:scale-[1.02] card-shimmer card-dance card-dance-6" style={{ filter: 'blur(0px)' }}>
              <div className="space-y-3">
                <div className="w-12 h-12 rounded-[16px] flex items-center justify-center icon-gradient text-gray-700">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                  </svg>
                </div>
                <h3 className="text-lg font-bold uppercase" style={{ fontFamily: 'aesthet-nova' }}>
                  <span className="bg-gradient-to-r from-[#9BCFFF] via-[#FCD4FE] to-[#B6F1F6] text-transparent bg-clip-text">Rights Management</span>
                </h3>
                <p className="text-sm text-black leading-relaxed">We manage your rights, so you don't have to</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    {/* Footer */}
    <Footer />
    </>
  );
};

export default About;
